import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { PortfolioAssetsType } from 'services/requests';
import { CommonCustomError } from 'types/errors';
import { useQueryParams } from 'hooks/routes';
import { QueryKeys } from 'constants/queryKeys';
import { Parameters } from 'constants/queryParameters';
import { useGetAllAssets } from './useGetAllAssets';

export const useGetProfileAssets = () => {
  const { isSuccess, data: allAssets } = useGetAllAssets();

  const queryFn =
    (profileId: number | undefined) => async (): Promise<PortfolioAssetsType> => {
      if (!allAssets) {
        throw new CommonCustomError();
      }

      const { data } = await api.getProfileAssets(profileId);

      const baseAsset = allAssets[data.baseAsset.id];
      if (!baseAsset) {
        throw new CommonCustomError();
      }

      const items = data.items.map((dataItem) => {
        const assetInfo = allAssets[dataItem.asset.id];
        if (!assetInfo) {
          throw new CommonCustomError();
        }
        return { ...dataItem, asset: assetInfo };
      });

      return {
        baseAsset,
        items,
      };
    };

  const profileId =
    useQueryParams(Parameters.iraUserId) ??
    useQueryParams(Parameters.independentIraUserId);
  const queryKey = [QueryKeys.profileAssets, profileId];

  return useQuery<PortfolioAssetsType, AxiosError<ApiError>>(
    queryKey,
    queryFn(Number(profileId)),
    {
      enabled: !!profileId && isSuccess,
      retry: 1,
    },
  );
};
